import "../style/page/report.scss";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { productorder, productorderid, sidebar } from "../redux/reducer/counterslice"
import { useEffect, useState, useMemo } from "react";
import { ProductOrderGet, diagnosticsissue } from "../../text/apidata";
import BasicTable from "../maincomponent/reacttable/table";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { NavLink } from "react-router-dom";
import noimage1 from "../../assets/images/noimage.png";
import ProductOrderForm from "../form/productorderform";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify"

function DiagnosticsIssue(props) {
  const [searchQuery, setSearchQuery] = useState("");
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [datacount, setdatacount] = useState();
  const [checked, setChecked] = useState(false);
  const [popup, setpopup] = useState(false)
  const [id, setid] = useState("")

  const dispatch = useDispatch()
  const dispatchid = useDispatch()
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const productstate = useSelector((state) => state.counter.productorder)
  const productid = useSelector((state) => state.counter.productorderid)
  const locationid = useSelector((state) => state.counter.loginuser_location_id)
  const [branches, setbranches] = useState(locationid != "all" ? locationid : "91");

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (searchQuery != "") {

      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(searchQuery);
      if (hasNumbers || hasLetters || hasSpecialChars) {

        axios({
          method: "get",
          url: diagnosticsissue,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            branch: branches,

          },
        })
          .then((res) => {
            console.log(res);
            setdatacount(res.data.data_count);
            settableheaderdata(res.data.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      axios({
        method: "get",
        url: diagnosticsissue,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          branch: branches,

        },
      })
        .then((res) => {
          console.log(res);
          setdatacount(res.data.data_count);
          settableheaderdata(res.data.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, productstate, popup, branches]);

  const dropdownhandlechange = (id, e) => {
    dispatchid(productorderid(id))
    dispatch(productorder("Edit"));

  }

  const columns = useMemo(
    () => [
      {
        Header: "Patient Name",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.patient.first_name +
                  row.row.original.patient.last_name
                }
              >
                {row.row.original.patient.first_name + " " +
                  row.row.original.patient.last_name}
              </p>
            </>
          );
        },
      },
      {
        Header: "UHID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.p_uhid}
              >
                {row.row.original.patient.p_uhid}
              </p>
            </>
          );
        },
      },
      {
        Header: "Phone No",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.patient.phonenumber}
              >
                {String(row.row.original.patient.phonenumber)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Report Type",
        accessor: "",

        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.issue_type.report_type}
              >
                {String(row.row.original.issue_type.report_type)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Description",
        accessor: "",
        Cell: (row) => {
          const items = [];
          items.push(row.row.original.description)

          // console.log(items.toString());
          const shorten =
            items.toString().length > 20
              ? `${items.toString().substring(0, 15)}...`
              : `${items.toString()}`;

          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={`${items.toString()}`}
              >
                {shorten}{" "}
                {/* here */}
              </p>
              <button
                style={{
                  padding: "5px",
                  background: "#5784f5",
                  color: "#fff",
                  fontSize: "14px",
                  border: "none",
                  outline: "none",
                  borderRadius: "10px",
                  cursor: "pointer",
                }}
                onClick={(e) => {
                  let isCopy = copy(row.row.original.description);
                  if (isCopy) {
                    toast.success("Copied to Clipboard");
                  }
                }}
              >
                <i class="fa fa-clone"></i>
              </button>
            </>
          );
        },
      },
      {
        Header: "Total Amount",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.order.total_amount}
              >
                {parseFloat(row.row.original.order.total_amount).toFixed(2)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Paid",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.order.total_amount}
              >
                {row.row.original.order.razorpay_diagnostics != null ? row.row.original.order.razorpay_diagnostics.isPaid == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (<p style={{ color: "green", fontWeight: 700 }}>Yes</p>) : "--"}
              </p>
            </>
          );
        },
      },
      {
        Header: "Fully used",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.fully_used}
              >
                {row.row.original.order.fully_used == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (<p style={{ color: "green", fontWeight: 700 }}>Yes</p>)}
              </p>
            </>
          );
        },
      },
      {
        Header: "Razorpay ID",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={row.row.original.order.diagnostic_order_id}
              >
                {row.row.original.order.razorpay_diagnostics.diagnostic_order_id == null ? "--" : row.row.original.order.razorpay_diagnostics.diagnostic_order_id}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row, index) => {
          // console.log(row.row);

          return (
            <>
              {/* <div class={"actions" +row.row.id}>
                      <input
                        class="form-check-input"
                        type="checkbox"
                        checked={row.row.original.fetaured_products}
                        onChange={(e) => {    
                            row.row.original.fetaured_products = !row.row.original.fetaured_products
                        }}
                        id={row.row.id}
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                      Featured Product
                      </label>
                    </div>               */}

              <div class="form-check form-switch">
                <input
                  class="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="flexSwitchCheckDefault"
                  checked={row.row.original.issue_solved}
                  onChange={(e) => {
                    console.log(e.target.checked)
                    setid(row.row.original.id);
                    setChecked(e.target.checked)
                    // if(e.target.checked==true){
                    setpopup(true);
                    // }
                  }}
                  style={{
                    cursor: "pointer"
                  }}

                ></input>
                <label class="form-check-label" for="flexSwitchCheckDefault">
                  Issue Solved Status
                </label>
              </div>
            </>
          );
        },
      },
    ],
    [popup]
  );

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const checkbox = (e) => {
    console.log(e.target.checked)
    setChecked(e.target.checked);

  };

  const confirm = () => {
    axios({
      method: "put",
      url: diagnosticsissue + id + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
      data: {
        issue_solved: checked
      }

    }).then((res) => {
      console.log(res)
      setpopup(false)


    }).catch((error) => {
      console.log(error)


    })
  }


  return (
    <>
      <div className={sideactive ? "productorder-sa" : "productorder"}>
        <div class="page-header-PO">
          <div class="row">
            <div class="col-sm-7 col-auto">
              <h3 class="page-title">Diagnostics Issue</h3>
              <ul class="breadcrumb">
                <li class="breadcrumb-item">
                  <NavLink
                    style={{ textDecoration: "none", color: "#333333" }}
                    to={"/"}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"))
                    }}
                  >
                    Dashboard
                  </NavLink>
                </li>
                <li class="breadcrumb-item active">Diagnostics Issue</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body" style={{ padding: "1.5rem" }}>
                <form onSubmit={handleSubmit}>
                  <div
                    class="input-group rounded"
                    style={{ width: "250px", height: "40px" }}
                  >
                    <input
                      type="search"
                      class="form-control rounded"
                      aria-label="Search"
                      aria-describedby="search-addon"
                      value={searchQuery}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) { e.preventDefault(); }
                      }}

                      onInput={(e) => {
                        if (e.target.value.length <= "100") {
                          setSearchQuery(e.target.value);

                        }
                        else {
                          e.preventDefault()
                        }
                      }}
                      // onKeyDown={(e)=>{if(e.which=="32"){
                      //   e.preventDefault()
                      // }}}

                      min="0"
                      max="10"
                      label="Search"
                      placeholder="Search..."
                      required
                    />
                    <span
                      class="input-group-text border-0 bg-transparent"
                      id="search-addon"
                    >
                      <i
                        class="bi bi-search"
                        style={{
                          color: "#1b5a90",
                          width: "20px",
                          height: "20px",
                        }}
                      ></i>
                    </span>
                  </div>
                </form>

                <div className="table-responsive">
                  <BasicTable
                    columns={columns}
                    data={tableheaderdata}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={datacount}
                    location={"others"}
                    setbranches={setbranches}
                    branches={branches}

                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {popup && (
        <>
          <div className="logout_popup">
            <div class="container1">
              <div class="cookiesContent" id="cookiesPopup">
                <button class="close" onClick={(e) => { setpopup(false) }}>✖</button>
                {/* <img src={logoutimg} alt="cookies-img" /> */}
                <p style={{ marginTop: "20px" }}>{checked ? "Do you Want to change status to Resolved?" : "Do you Want to change status back to Not Resolved?"}</p>
                <div style={{ display: "flex" }}>
                  <button class="accept p-2 m-2" onClick={(e) => confirm()}>Yes!</button>
                  <button class="accept p-2 m-2" onClick={(e) => setpopup(false)}>No</button>
                </div>
              </div>
            </div>
          </div>

        </>
      )}

    </>
  );
}

export default DiagnosticsIssue;

